/**
 * Section Header Component
 * 
 * Standardized component for section titles and descriptions across the app.
 * Wraps title and description in a container with consistent spacing.
 */

import type { ReactNode } from 'react'
import { cn } from '@/lib/utils'

interface SectionHeaderProps {
  title: string | ReactNode
  description?: string | ReactNode
  className?: string
}

export function SectionHeader({ title, description, className }: SectionHeaderProps) {
  return (
    <div className={cn('mb-4', className)}>
      <h3 className="font-medium mb-2 px-6">{title}</h3>
      {description && (
        <p className="text-sm text-muted-foreground mb-2 px-6">{description}</p>
      )}
    </div>
  )
}

